import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import logo from '../assets/onionlogo.png'; // ✅ adjust path to your logo file

const ProtectedRoute = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();

    // Listen for Firebase auth state changes
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe(); // cleanup listener on unmount
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
          background: '#F0DcE7',
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        <img
          src={logo}
          alt="App Logo"
          style={{
            width: "250px",
            marginBottom: "25px",
            animation: "pulse 1.5s infinite",
          }}
        />

        {/* Spinner */}
        <div
          style={{
            width: "55px",
            height: "55px",
            border: "6px solid #f3f3f3",
            borderTop: "6px solid #9c27b0", // Purple accent
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        ></div>

        {/* Inline keyframes for animations */}
        <style>
          {`
            @keyframes pulse {
              0% { transform: scale(1); opacity: 0.9; }
              50% { transform: scale(1.05); opacity: 1; }
              100% { transform: scale(1); opacity: 0.9; }
            }
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
